export const LiveBaseURL = "https://beastwebapi.azurewebsites.net/";

export const DevelopementBaseURL = "https://contolioapi.azurewebsites.net/logs";
